export const ActionTypes = {
  SET_ACTUAL_PAGE: 'SET_ACTUAL_PAGE',
  SET_USER: 'SET_USER',
  SET_SELECTED_REPORT: 'SET_SELECTED_REPORT',
};
